import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Menu.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate, useParams } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import Spinner from "../components/CTA/Spinner";

export default function Menu({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  destroySession,
  companyData,
  reload,
  setReload,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;
  const { orderid } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const logout = () => {
    destroySession();
    navigate("/");
  };

  const becomeSeller = async () => {
    setIsLoading(true);

    const resa = await fetch(
      `${apiURL}/api/companies/index.php?id=` + companyData.id.toString(),
      {
        method: "POST",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          isACreator: 1,
        }),
      }
    );

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = (value) => {
    setIsLoading(false);
    setReload(!reload);
    navigate("/seller");
  };

  return (
    <div className="menu">
      {isMobile ? (
        <div className="menu_topnav">
          <div
            className="menu_topnav_left"
            onClick={() => (isEmpty(authToken) ? navigate("/") : navigate(-1))}>
            <ArrowBack /> Menu
          </div>
        </div>
      ) : (
        <div className="menu_topnav">
          <div
            className="menu_topnav_left_title"
            onClick={() => (isEmpty(authToken) ? navigate("/") : navigate(-1))}>
            <ArrowBackDesktop />
            Menu{" "}
          </div>
        </div>
      )}
      <div className="menu_body">
        <div className="menu_body_list">
          {isEmpty(authToken) ? (
            <>
              <div
                className="menu_body_list_element"
                onClick={() => navigate("/login")}>
                Neu Registrieren / Einloggen
              </div>
            </>
          ) : (
            <div className="menu_body_list_element" onClick={() => logout()}>
              Logout
            </div>
          )}
          {isEmpty(authToken) ? (
            <div
              className="menu_body_list_element"
              onClick={() => navigate("/becomeSeller")}>
              Geld verdienen als Creator
            </div>
          ) : (
            <>
              {!isEmpty(companyData) && companyData.isACreator == 0 && (
                <div
                  className="menu_body_list_element"
                  onClick={() => navigate("/becomeSeller")}>
                  Geld verdienen als Creator
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
